import { useEffect, useState } from "react";

import NotFound from '@components/pages/NotFound';
import { get_data_course, submit_voucher } from "../../utils/apiCall";
import topLogo from '@assets/images/top-logo.png';
import logo from "../../assets/images/logo-black-bg.png";
import { toast, ToastContainer } from "react-toastify";
import { useParams } from "react-router";
import _ from 'lodash';
// import Rating from "react-rating";

import 'react-toastify/dist/ReactToastify.css';
import '../../styles/voucher-leanding-page.scss';

const mapper = (data) => {
    return {
        product_id   : data?.ProductId,
        coupon_code  : data?.CourseCode,
        desc         : data?.Description,
        telegroup_url: data?.TelegramUrl,
        class_name   : data?.NamaKelas,
        prefix       : data?.Prefix,
        thumbnail    : data?.ImageUrl,
        rating       : data?.Rating ?? 0,
        review_count : data?.ReviewCount ?? 0,
        participant  : data?.Participant ?? 0,
        global       : !!data?.IsGlobal,
        product_ids  : _.mapValues(data.ProductIds, v => _.mapKeys(v, (value, key) => _.snakeCase(key))),
        vendor       : data?.Vendor || null
    }
}

const PMO_VOUCHERS = [
    "demo1",
    "demo2",
    "demo3",
    "demo4",
    "demo5",
    "demo6",
    "demo7",
    "demo8",
    "demo9",
    "demo10",
    "demo11",
    "demo12",
    "demo13",
    "demo14",
    "demo15",
    "demo16",
    "demo17",
    "voucherdummy1",
    "voucherdummy2",
    "voucherdummy3",
    "voucherdummy4",
    "voucherdummy5",
    "voucherdummy6",
    "voucherdummy7",
    "voucherdummy8",
    "voucherdummy9",
    "voucherdummy10",
    "voucherdummy11",
    "voucherdummy12",
    "voucherdummy13",
    "voucherdummy14",
    "voucherdummy15",
    "voucherdummy16",
    "voucherdummy17",
];

const VoucherLandingPage = () => {
    const { slug } = useParams();
    const [siteTitle, setSiteTitle] = useState("Mastering Skill");
    const [siteLogo, setSiteLogo] = useState(topLogo);
    const [isVendorPage, setIsVendorPage] = useState(false);
    const [EmailAddress, setEmailAddress] = useState('csmasteringskill@gmail.com');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [data, setData] = useState({});
    const [voucherCode, setVoucherCode] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        get_data_course(slug)
            .then(promise => promise.json())
            .then(data => {
                setData(mapper(data));
                if (!!data?.NamaKelas) {
                    document.title = `MasteringSkill - ${data?.NamaKelas}`;
                }

                setIsVendorPage(!!data?.Vendor);
                setSiteTitle( _.get(data?.Vendor, 'VendorLms', 'Mastering Skill') );
                setSiteLogo( _.get(data?.Vendor, 'Logo[0].thumbnails.small.url', topLogo) );
                setEmailAddress( _.get(data?.Vendor, 'ContactEmail', 'csmasteringskill@gmail.com') );
                setPhoneNumber( _.get(data?.Vendor, 'PhoneNumber', null) );
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => setLoading(false));
    }, [slug])

    const getInternationalPhoneNumber = (str) => {
        return String(str).replace(/\D/g, '').replace(/^0/, "62");
    }

    const handleSubmitVoucher = () => {
        if (!voucherCode) {
            toast.error("Invalid Coupon Code");
            return;
        }

        if (slug === 'Tokopedia-belajar-mengoperasikan-spreadsheet-untuk-menjadi-seorang-sekretaris') {
            const productId = data.product_id;
            import('@static/1459733-vouchers.json').then(data => {
                const voucherData = _.find(data, {submitted_voucher: voucherCode});
                if (!voucherData) {
                    toast.error("Invalid Coupon Code");
                    return;
                }

                window.location.href = `https://www.masteringskill.com/enroll/${productId}?coupon=${voucherData.valid_voucher}`;
                return;
            })
        } else {
            let productId = data.product_id;
            let prefixCode = data.prefix;

            if (!!data.global) {
                let selectedProduct;
                const DPPrefix = _.toUpper(voucherCode).substring(0,2);
                // get correct product id, use short slug if exists and fallback to longer slug.
                switch (DPPrefix) {
                    case 'PT':
                        selectedProduct = _.get(data.product_ids, 'ptr', _.get(data.product_ids, 'pintaria'));
                        break;
                    case 'SM':
                        selectedProduct = _.get(data.product_ids, 'smu', _.get(data.product_ids, 'sekolahmu'));
                        break;
                    case 'TP':
                        selectedProduct = _.get(data.product_ids, 'tkp', _.get(data.product_ids, 'tokopedia'));
                        break;
                    case 'PM':
                        selectedProduct = _.get(data.product_ids, 'pmh', _.get(data.product_ids, 'pijar mahir'));
                        break;
                    case 'BL':
                        selectedProduct = _.get(data.product_ids, 'blp', _.get(data.product_ids, 'bukalapak'));
                        break;
                    case 'FD':
                        selectedProduct = _.get(data.product_ids, 'fdg', _.get(data.product_ids, 'fordigi'));
                        break;
                    default:
                        break;
                }

                const dpReplaced = voucherCode.replace(DPPrefix, '');
                // if voucher contain DP prefix and it is a PMO Voucher, route to desired product.
                if ((voucherCode !== dpReplaced) && PMO_VOUCHERS.includes(dpReplaced)) {
                    productId = _.get(selectedProduct, 'product_id');
                    return submit_voucher(productId, dpReplaced, '');
                } else if (PMO_VOUCHERS.includes(voucherCode)) {
                    selectedProduct = _.get(data.product_ids, 'tkp', _.get(data.product_ids, 'tokopedia', _.get(data.product_ids, 'belajar')));
                }

                if (!!selectedProduct) {
                    productId = _.get(selectedProduct, 'product_id');
                    prefixCode = _.get(selectedProduct, 'prefix');
                }
            }

            fetch(`https://api.maubelajarapa.com/thinkific/redeem/${voucherCode}`)
                .then(response => response.json())
                .then(data => {
                    if (!data.url) {
                        throw new Error('Voucher not found');
                    }

                    window.location.href = data.url;
                })
                .catch(err => {
                    console.log('e', err)
                    // alert(`ProductID: ${productId}, voucher: ${voucherCode}, prefix: ${prefixCode}`);
                    // return;
                    // console.log('data', {voucherCode, data});
                    submit_voucher(productId, voucherCode, prefixCode);
                });
        }
    }

    const handleJoinGroupTele = () => {
        window.open(
            data.telegroup_url,
            '_blank'
        )
    }

    if (loading) {
        return null;
    }

    return !data?.product_id ? <NotFound /> : (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 header-logo">
                        <img alt={siteTitle} src={siteLogo} />
                    </div>
                </div>
            </div>
            <ToastContainer />
            <div className="header">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 course-image-container">
                            <img src={data.thumbnail} alt={data.class_name} loading="lazy"/>
                        </div>
                        <div className="col-md-8">
                            {
                                !isVendorPage &&
                                    <div className="logo">
                                        <img src={logo} alt={"logo"}/>
                                    </div>
                            }
                            <div className="title">
                                {data.class_name}
                            </div>
                            {/* <div className="overview">
                                <div className="rating">
                                    <Rating
                                        emptySymbol="fa fa-star disabled"
                                        fullSymbol="fa fa-star active"
                                        readonly={true}
                                        initialRating={data.rating}
                                    />
                                    {data.rating}/5 ({data.review_count} ulasan)
                                </div>
                                <div className="participant">
                                    <i className="fa fa-user"/>
                                    {data.participant} Peserta
                                </div>
                            </div> */}
                            {/* <div className="quick-desc">
                                {data.desc}
                            </div> */}
                            <div className="voucher-form">
                                <p className="form-title">
                                    Punya Voucher?
                                </p>
                                <div className="form-input">
                                    <input autoComplete="off" value={voucherCode} onChange={(e) => setVoucherCode(e.target.value)} placeholder="Masukkan kode voucher disini"/>
                                    <button onClick={handleSubmitVoucher}>Pakai</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="body">
                <div className="container">
                    { !!data.telegroup_url && (
                    <>
                        Gabung ke grup Telegram untuk berdiskusi dengan teman sekelas. <br/>
                        Klik logo di bawah.
                        <div className="btn-group">
                            <button onClick={handleJoinGroupTele}>
                                <i className="icon fab fa-telegram" />
                                Gabung Group Telegram
                            </button>
                        </div>
                    </>
                    ) }
                    <div className="title">Penukaran Kode Voucher {!isVendorPage && " MasteringSkill"}</div>

                    Masukkan kode voucher yang didapat dari email untuk mulai belajar di {!isVendorPage ? "kelas MasteringSkill." : "."} Langkah masuk ke kelas:
                    <ol>
                        <li>Salin kode voucher dari email ke kolom “<strong>Masukan kode voucher di sini.</strong>”</li>
                        <li>Klik tombol “<strong>Pakai</strong>”.</li>
                        <li>Kamu akan diarahkan ke website {isVendorPage ? "halaman pendaftaran" : "MasteringSkill"}. Jika sudah punya akun, klik “<strong>Saya sudah punya akun.</strong>” Jika belum punya, silakan <strong>daftar dengan Google, Facebook, atau email.</strong></li>
                        <li>Kamu sudah bisa belajar setelah punya akun. Tekan tombol “<strong>Mulai Belajar</strong>” pada kelas yang kamu beli. </li>
                        <li>Selamat belajar!</li>
                    </ol>

                    <div className="title">Syarat dan Ketentuan</div>
                    <ol>
                        <li>Voucher hanya dapat ditukarkan sebanyak 1 (satu) kali</li>
                        <li>Kode voucher untuk 1 kelas tidak dapat digunakan untuk kelas lainnya</li>
                        <li>Tidak dapat dilakukan refund/pengembalian dana untuk kode voucher yang telah dibeli</li>
                        <li>Video pembelajaran tidak dapat dipercepat dan/atau di skip</li>
                        <li><strong>Untuk dapat mengakses kelas, peserta diwajibkan untuk memiliki akun di {isVendorPage ? "halaman berikut" : "masteringskill.com"}. Dalam pembuatan akun, Peserta Prakerja harus memasukkan nama yang sesuai/sama dengan nama pada KTP dan akun Prakerja milik Peserta</strong></li>
                        <li>Untuk mendapatkan sertifikat, Peserta harus menyelesaikan kelas dan test/quiz yang diberikan</li>
                        <li>Kode voucher berlaku hingga <strong>15 Desember 2022</strong></li>
                        {
                            !isVendorPage &&
                                <li>Segala materi maupun muatan yang tercantum dalam video pembelajaran merupakan Hak Kekayaan Intelektual (HKI) milik Mastering Skill yang tidak dapat dipublikasikan dan/atau diunggah kembali oleh pihak lain tanpa izin Mastering Skill</li>
                        }
                        <li>Apabila terdapat kendala dalam penggunaan voucher, dapat menghubungi kami pada email <a className="bold-link" href={`mailto:${EmailAddress}`}>{EmailAddress}</a> {!!phoneNumber && 'atau hubungi WA'} {!!phoneNumber && <a href={`https://wa.me/${getInternationalPhoneNumber(phoneNumber)}`}>{phoneNumber}</a>}</li>
                    </ol>
                </div>
            </div>
            {
                !isVendorPage &&
                    <div className="footer">
                        <div className="container">
                            © {new Date().getFullYear()} Mastering Skill - PT Jaya Dinamika Digital
                        </div>
                    </div>
            }
        </>
    )
}

export default VoucherLandingPage;
